import { useCookieConsent } from '@/hooks/useCookieConsent';
import { CookiePreferencesModal } from './CookiePreferencesModal';

interface CookiePreferencesButtonProps {
  className?: string;
  children?: React.ReactNode;
}

export const CookiePreferencesButton = ({ 
  className = "text-sm text-background/60 hover:text-background transition-colors cursor-pointer",
  children = "Manage Cookies"
}: CookiePreferencesButtonProps) => {
  const {
    consent,
    openPreferences,
    closePreferences,
    showPreferences,
    updateConsent,
    acceptAll,
    rejectNonEssential,
  } = useCookieConsent();

  return (
    <>
      <button
        type="button"
        onClick={openPreferences}
        className={className}
      >
        {children}
      </button>
      
      <CookiePreferencesModal
        open={showPreferences}
        onClose={closePreferences}
        consent={consent}
        onSave={updateConsent}
        onAcceptAll={acceptAll}
        onRejectNonEssential={rejectNonEssential}
      />
    </>
  );
};
